import { Injectable } from '@angular/core';
import { mainMapMngr, IMapEventsSubscriber } from '../asp/MapMngr';
import { TempDrawingsPool, TempDrawingDataType, TempDrawingObject } from '../asp/temp-drawings';
import { Point } from '../common/Point';

@Injectable({
  providedIn: 'root'
})
export class BullsEyeService implements IMapEventsSubscriber{
  
  private active: boolean = false;
  private readout: TempDrawingObject = null;
  private mousePixel: Point = null;
  private bullsEye: NeWMI.Geometry.Point = null;

  constructor() {
    mainMapMngr.addMapEventsSubscriber(this);
  }

  toggleActive() {
    this.active = !this.active;
  }

  isActive(): boolean {
    return this.active;
  }

  onMouseMove(pixel: Point): void {
    this.mousePixel = pixel;
    if (!this.active)
      return;
    if (this.mousePixel) {
      this.updateReadout();
    }
    else {
      if (this.readout) {
        TempDrawingsPool.getSelf().deleteTempDrawing(this.readout);
        this.readout = null;
      }
    }
  }

  onExtentChange(): void {
    if (!this.active)
      return;
    if (this.mousePixel)
      this.updateReadout();
  }

  private updateReadout() {
    let convertedPoint = mainMapMngr.pixelToMapLocation({ x: this.mousePixel.x + 15, y: this.mousePixel.y + 15});            
    let geom = new NeWMI.Geometry.Point(convertedPoint);
    if (this.readout)
      this.readout.updateGeometry(geom);
    else
      this.readout = TempDrawingsPool.getSelf().createTempDrawing(TempDrawingDataType.Text, geom,
        { value: '38 deg', color: 'white', alignment: { horizontal: 'left', vertical: 'top' } });

  }
}
